// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e63I","delete":"styles_delete__3PhYd","update":"styles_update__2qfdM","add":"styles_add__aFRX4"};